let teamPhysica = [
  {
    path: '/team_examination',
    name: '机构列表',
    component: () => import('@/pages/teamPhysicalExamination/originList.vue')
  },
  {
    path: '/team_examination_order_list',
    name: '套餐选择',
    component: () => import('@/pages/teamPhysicalExamination/orderList.vue')
  },
  {
    path: '/team_examination_order_item_detail',
    name: '套餐详情',
    component: () => import('@/pages/teamPhysicalExamination/physicalExamination_detail.vue')
  },
  {
    path: '/team_examination_confrim_order',
    name: '人员配置',
    component: () => import('@/pages/teamPhysicalExamination/orderConfrim.vue')
  },
  {
    path: '/team_examination_order_pay',
    name: '订单详情',
    component: () => import('@/pages/teamPhysicalExamination/physicalExamination_orderPay.vue')
  },
  {
    path: '/team_examination_order_pay_loading',
    name: '订单详情',
    component: () => import('@/pages/teamPhysicalExamination/pay_order_loading.vue')
  },
  {
    path: '/team_examination_change_time',
    name: '体检变更',
    component: () => import('@/pages/teamPhysicalExamination/physicalExamination_change_time.vue')
  },
  {
    path: '/team_examination_express_person_list',
    name: '温馨提示',
    component: () => import('@/pages/teamPhysicalExamination/pexpressPersonList.vue')
  },
  {
    path: '/team_examination_person_list',
    name: '人员名单',
    component: () => import('@/pages/teamPhysicalExamination/personList.vue')
  }
]

export default teamPhysica
